const canBeResized = (url: string): boolean => {
    return !url.startsWith('data:');
  };
  
  export const getResizedImageUrl = (url: string | undefined | null, options = { width: 100, cache: '31536000' }) => {
  if (!url) {
    return '';
  }

  if (!canBeResized(url)) {
    return url;
  }

  // Ensure cache param is set to 31536000 seconds (1 year) unless overridden
  const opts = { ...options, cache: options.cache || '31536000' };
  const optionsString = Object.keys(opts)
    .map((item) => `${item}=${opts[item as keyof typeof opts]}`)
    .join(',');
  return `https://media.solana-cdn.com/image/${optionsString}/${url}`;
};
